/* 顶部和左侧导航 */
import Layout from "../pages/layout"


/* 左侧导航 */
export const slideBar = [{
		path: "/",
		name: "home",
		redirect: "/home",
		component: Layout,
		meta: {
			title: "首页",
		},
		children: [{
			path: "/home",
			name: "home",
			meta: {
				title: "首页",
			},
			component: () => import('@/pages/home')
		}]
	},{
		path: "/uploadresource",
		name: "uploadresource",
		// redirect: "/uploadresource",
		component: Layout,
		meta: {
			title: "资料上传",
		},
		children: [{
				path: "/uploadresource",
				name: "uploadresource",
				meta: {
					title: "资料上传",
				},
				component: () => import('@/pages/uploadresource')
			},
			{
				path: "/bklist",
				name: "bklist",
				meta: {
					title: "备课列表",
				},
				component: () => import('@/pages/uploadresource/bklist')
			},
			{
				path: "/addresource",
				name: "addresource",
				meta: {
					title: "上传资源"
				},
				component: () => import('@/pages/uploadresource/addresource')
			}
		]
	},
	{
		path: "/checkresource",
		name: "checkresource",
		component: Layout,
		meta: {
			title: "内容审核",
		},
		children: [{
			path: "/shzylist",
			name: "checkresource",
			title: "资源审核",
			component: () => import('@/pages/studiosh/zylist')
		},{
			path: "/dzxsz",
			name: "dzxszs",
			title: "大中小思政",
			component: () => import('@/pages/studiosh/dzxsz')
		},{
			path: "/studiosh",
			name: "studiosh",
			title: "工作室审核",
			component: () => import('@/pages/studiosh/index')
		},{
			path: "/sfzxsh",
			name: "studiosh",
			title: "示范中心审核",
			component: () => import('@/pages/studiosh/sfzxsh')
		},{
			path: "/kcsfk",
			name: "kcsfks",
			title: "示范课审核",
			component: () => import('@/pages/studiosh/kcsfk')
		},{
			path: "/sfschool",
			name: "sfschools",
			title: "示范学校审核",
			component: () => import('@/pages/studiosh/sfschool')
		},{
			path: "/sfjks",
			name: "sfjks",
			title: "思政金课审核",
			component: () => import('@/pages/studiosh/szjksh')
		}]
	},
	// 实践基地
	{
		path: "/sjjd",
		name: "sjjd",
		component: Layout,
		meta: {
			title: "实践基地",
		},
		children: [{
			path: "/sjjdlist",
			name: "sjjdlist",
			title: "实践基地",
			component: () => import('@/pages/sjjd/index')
		},{
			path: "/sjjdadd",
			name: "sjjdadd",
			title: "添加实践基地",
			component: () => import('@/pages/sjjd/sjjdadd')
		},{
			path: "/xxzy",
			name: "xxzy",
			title: "学习资源列表",
			component: () => import('@/pages/sjjd/xxzy')
		},{
			path: "/xxzyadd",
			name: "xxzyadd",
			title: "学习资源添加",
			component: () => import('@/pages/sjjd/xxzyadd')
		},{
			path: "/sjxmlist",
			name: "sjxmlist",
			title: "实践项目",
			component: () => import('@/pages/sjjd/sjxm')
		},{
			path: "/sjxmadd",
			name: "sjxmadd",
			title: "实践项目添加",
			component: () => import('@/pages/sjjd/sjxmadd')
		},
		{
			path: "/sjhds",
			name: "sjhds",
			title: "实践活动",
			component: () => import('@/pages/sjjd/sjhd')
		},
		{
			path: "/hdbgadd",
			name: "hdbgadd",
			title: "新增活动报告",
			component: () => import('@/pages/sjjd/hdbgadd')
		},
		{
			path: "/exportsPdf",
			name: "exportsPdf",
			title: "实践活动报告",
			component: () => import('@/pages/sjjd/exportsPdf')
		},
		{
			path: "/sjhdadd",
			name: "sjhdadd",
			title: "实践活动添加",
			component: () => import('@/pages/sjjd/sjhdadd')
		},{
			path: "/jdsh",
			name: "jdsh",
			title: "实践基地审核",
			component: () => import('@/pages/studiosh/jdsh')
		},{
			path: "/xmsh",
			name: "xmsh",
			title: "实践项目审核",
			component: () => import('@/pages/studiosh/xmsh')
		},{
			path: "/hdsh",
			name: "hdsh",
			title: "实践活动审核",
			component: () => import('@/pages/studiosh/hdsh')
		},{
			path: "/hdcg",
			name: "hdcgs",
			title: "实践活动成果",
			component: () => import('@/pages/sjjd/hdcg')
		},{
			path: "/hdcgadd",
			name: "hdcgadds",
			title: "实践活动成果添加",
			component: () => import('@/pages/sjjd/hdcgadd')
		},{
			path: "/hdcys",
			name: "hdcys",
			title: "实践活动成员列表",
			component: () => import('@/pages/sjjd/hdcy')
		},{
			path: "/hdcyadd",
			name: "hdcyadds",
			title: "实践活动成员详情",
			component: () => import('@/pages/sjjd/hdcyadd')
		},{
			path: "/gwlist",
			name: "gwlists",
			title: "感悟列表",
			component: () => import('@/pages/sjjd/gwlist')
		}]
	},
	// 活动管理
	{
		path: "/hdgl",
		name: "hdgl",
		component: Layout,
		meta: {
			title: "活动管理",
		},
		children: [{
			path: "/hdgl",
			name: "hdgl",
			title: "活动管理",
			component: () => import('@/pages/hdgl/index')
		},{
			path: "/hdgladd",
			name: "hdgladd",
			title: "活动添加",
			component: () => import('@/pages/hdgl/hdgladd')
		}]
	},
	// 学院风采
	{
		path: "/xyfc",
		name: "xyfc",
		component: Layout,
		meta: {
			title: "学院风采",
		},
		children: [{
			path: "/xyfc",
			name: "xyfclist",
			title: "学院风采列表",
			component: () => import('@/pages/xyfc/index')
		},{
			path: "/xyfck",
			name: "xyfck",
			title: "学院风采查看",
			component: () => import('@/pages/xyfc/tzgg')
		},{
			path: "/xyfcadd",
			name: "xyfcadd",
			title: "学院风采添加",
			component: () => import('@/pages/xyfc/kyadd')
		}]
	},
	//讲师备课
	{
		path: "/jsbk",
		name: "jsbk",
		component: Layout,
		meta: {
			title: "讲师备课",
		},
		children: [{
			path: "/jsbklist",
			name: "jsbklist",
			title: "教案管理",
			component: () => import('@/pages/jsbk/index')
		},{
			path: "/jalist",
			name: "jalist",
			title: "教案列表",
			component: () => import('@/pages/jsbk/jalist')
		},{
			path: "/zjadd",
			name: "zjadd",
			title: "章节添加",
			component: () => import('@/pages/jsbk/zjadd')
		},{
			path: "/zjck",
			name: "zjck",
			title: "章节预览",
			component: () => import('@/pages/jsbk/zjck')
		},{
			path: "/jagj",
			name: "jagj",
			title: "教案共建",
			component: () => import('@/pages/jsbk/jagj')
		}]
	},
	// 学校宣传
	{
		path: "/schoolxc",
		name: "schoolxc",
		component: Layout,
		meta: {
			title: "学校宣传",
		},
		children: [{
			path: "/schoolxc",
			name: "schoolxc",
			title: "学校宣传列表",
			component: () => import('@/pages/schoolxc/index')
		},{
			path: "/schoolxcadd",
			name: "schoolxcadd",
			title: "学校宣传添加",
			component: () => import('@/pages/schoolxc/schoolxcadd')
		},{
			path: "/schoolxck",
			name: "schoolxck",
			title: "学校宣传查看",
			component: () => import('@/pages/schoolxc/schoolxck')
		}]
	},
	// 师资培训
	{
		path: "/szpx",
		name: "szpx",
		component: Layout,
		meta: {
			title: "师资培训",
		},
		children: [{
			path: "/szpxlist",
			name: "szpxlist",
			title: "师资培训",
			component: () => import('@/pages/szpx/index')
		},{
			path: "/szpxadd",
			name: "szpxadd",
			title: "发布通知",
			component: () => import('@/pages/szpx/szpxadd')
		},{
			path: "/szpxck",
			name: "szpxck",
			title: "查看通知",
			component: () => import('@/pages/szpx/szpxck')
		},{
			path: "/pxkclist",
			name: "pxkclist",
			title: "培训课程",
			component: () => import('@/pages/szpx/pxkclist')
		},{
			path: "/pxkcadd",
			name: "pxkcadd",
			title: "上传培训课程",
			component: () => import('@/pages/szpx/pxkcadd')
		},{
			path: "/pxkcck",
			name: "pxkcck",
			title: "培训课程查看",
			component: () => import('@/pages/szpx/pxkcck')
		}]
	},
	// 新闻管理
	{
		path: "/News",
		name: "News",
		meta: {
			title: "新闻管理",
		},
		component: Layout,
		children: [{
			path: "/News",
			name: "Newss",
			title: "新闻管理",
			component: () => import('@/pages/News/index')
		},{
			path: "/newsadd",
			name: "newsadd",
			title: "新闻添加",
			component: () => import('@/pages/News/newsadd')
		}]
	},
	//大中小思政建设
	{
		path: "/szjs",
		name: "szjs",
		meta: {
			title: "大中小思政建设",
		},
		component: Layout,
		children: [{
			path: "/szjs",
			name: "szjs",
			title: "大中小思政建设",
			component: () => import('@/pages/szjs/index')
		},{
			path: "/szjsadd",
			name: "szjsadd",
			title: "大中小思政建设添加",
			component: () => import('@/pages/szjs/szjsadd')
		},{
			path: "/dsjzy",
			name: "dsjzy",
			title: "观测数据",
			component: () => import('@/pages/dsjzy/index')
		},{
			path: "/dsjzyadd",
			name: "dsjzyadds",
			title: "观测数据编辑",
			component: () => import('@/pages/dsjzy/dsjzyadd')
		}]
	},
	// 成果展示
	{
		path: "/cgzs",
		name: "cgzs",
		meta: {
			title: "成果展示",
		},
		component: Layout,
		children: [{
			path: "/cgzs",
			name: "cgzs",
			title: "成果展示",
			component: () => import('@/pages/cgzs/index')
		},{
			path: "/cgzsadd",
			name: "cgzsadd",
			title: "成果添加",
			component: () => import('@/pages/cgzs/cgzsadd')
		}]
	},
	// 共建共享
	{
		path: "/gjgx",
		name: "gjgx",
		meta: {
			title: "共建共享",
		},
		component: Layout,
		children: [{
			path: "/gjgx",
			name: "gjgx",
			title: "共建共享",
			component: () => import('@/pages/gjgx/index')
		},{
			path: "/gjgxadd",
			name: "gjgxadd",
			title: "共建共享添加",
			component: () => import('@/pages/gjgx/gjgxadd')
		}]
	},
	// 教学比赛
	{
		path: "/gamelist",
		name: "gamelist",
		meta: {
			title: " 教学比赛",
		},
		component: Layout,
		children: [{
			path: "/gamelists",
			name: "gamelists",
			title: "比赛列表",
			component: () => import('@/pages/gamelist/index')
		},{
			path: "/gameadd",
			name: "gameadd",
			title: "新增比赛",
			component: () => import('@/pages/gamelist/gameadd')
		},{
			path: "/gameacy",
			name: "gameacy",
			title: "成员列表",
			component: () => import('@/pages/gamelist/cylist')
		},{
			path: "/gameazp",
			name: "gameazp",
			title: "作品列表",
			component: () => import('@/pages/gamelist/zplist')
		},{
			path: "/gameazj",
			name: "gameazj",
			title: "专家列表",
			component: () => import('@/pages/gamelist/zjlist')
		},{
			path: "/gameazjdd",
			name: "gamezjadd",
			title: "添加专家",
			component: () => import('@/pages/gamelist/zjadd')
		}]
	},
	// 大先生
	{
		path: "/dax",
		name: "daxs",
		meta: {
			title: " 大先生培育",
		},
		component: Layout,
		children: [{
			path: "/daxlist",
			name: "daxlist",
			title: "最美教师列表",
			component: () => import('@/pages/dax/index')
		},{
			path: "/daxadd",
			name: "daxadds",
			title: "添加教师",
			component: () => import('@/pages/dax/daxadd')
		}]
	},
	// 思政共同体管理
	{
		path: "/gtt",
		name: "gtt",
		meta: {
			title: "思政共同体",
		},
		component: Layout,
		children: [{
			path: "/gttsjhd",
			name: "gttsjhd",
			title: "实践活动",
			component: () => import('@/pages/gtt/sjhdindex')
		},{
			path: "/sjhdadds",
			name: "sjhdadd",
			title: "实践活动",
			component: () => import('@/pages/gtt/sjhdadd')
		},{
			path: "/sfjk",
			name: "sfjk",
			title: "示范金课",
			component: () => import('@/pages/gtt/sfjk')
		},{
			path: "/sfjkadd",
			name: "sfjkadd",
			title: "示范金课添加",
			component: () => import('@/pages/gtt/sfjkadd')
		},{
			path: "/yjcg",
			name: "yjcg",
			title: "研究成果",
			component: () => import('@/pages/gtt/yjcg')
		},{
			path: "/yjcgadd",
			name: "yjcgadd",
			title: "研究成果添加",
			component: () => import('@/pages/gtt/yjcgadd')
		},{
			path: "/gttindex",
			name: "gttindex",
			title: "共同体列表",
			component: () => import('@/pages/gtt/gttindex')
		},{
			path: "/gttcy",
			name: "gttcy",
			title: "共同体成员列表",
			component: () => import('@/pages/gtt/gttcy')
		},{
			path: "/gttadd",
			name: "gttadd",
			title: "共同体添加",
			component: () => import('@/pages/gtt/gttadd')
		},{
			path: "/gttcyadd",
			name: "gttcyadd",
			title: "共同体成员添加",
			component: () => import('@/pages/gtt/gttcyadd')
		}]
	},
	// 课程思政管理
	{
		path: "/kcsz",
		name: "kcsz",
		meta: {
			title: "课程思政",
		},
		component: Layout,
		children: [{
			path: "/sfkindex",
			name: "sfkindex",
			title: "示范课程",
			component: () => import('@/pages/kcsz/sfk')
		},{
				path: "/addresource2",
				name: "addresource2",
				meta: {
					title: "上传资源"
				},
				component: () => import('@/pages/uploadresource/addresource2')
		},{
			path: "/sfkadd",
			name: "sfkadd",
			title: "示范课程添加",
			component: () => import('@/pages/kcsz/sfkadd')
		},{
			path: "/sfkschool",
			name: "sfkschool",
			title: "示范学校",
			component: () => import('@/pages/kcsz/sfkschool')
		},
		{
			path: "/sfkschooladd",
			name: "sfkschooladd",
			title: "添加示范学校",
			component: () => import('@/pages/kcsz/sfkschooladd')
		},
		{
			path: "/specialgl",
			name: "specialgl",
			title: "示范中心",
			component: () => import('@/pages/special/specialgl')
		},
		{
			path: "/specialgladd",
			name: "specialgladd",
			title: "示范中心添加",
			component: () => import('@/pages/special/specialgladd')
		},{
			path: "/caseadd",
			name: "caseadd",
			title: "成果案例添加",
			component: () => import('@/pages/special/caseadd')
		},
		{
			path: "/policyadd",
			name: "policyadd",
			title: "政策文件添加",
			component: () => import('@/pages/special/policyadd')
		},{
			path: "/activity",
			name: "activity",
			title: "中心活动添加",
			component: () => import('@/pages/special/activity')
		},{
			path: "/sfzxcontent",
			name: "speciallist",
			title: "添加内容",
			component: () => import('@/pages/special/sfzxcontent')
		},{
			path: "/jxmsindex",
			name: "jxmsindex",
			title: "教学名师",
			component: () => import('@/pages/kcsz/jxmslist')
		},{
			path: "/jxmsadd",
			name: "jxmsadd",
			title: "教学名师",
			component: () => import('@/pages/kcsz/jxms')
		},{
			path: "/kcdsjzy",
			name: "dsjzy",
			title: "观测数据",
			component: () => import('@/pages/kcsz/index')
		},{
			path: "/kcdsjzyadd",
			name: "dsjzyadds",
			title: "观测数据编辑",
			component: () => import('@/pages/kcsz/dsjzyadd')
		},{
			path: "/kcglist",
			name: "kcglists",
			title: "成果案例",
			component: () => import('@/pages/kcsz/xmlist')
		},{
			path: "/kcgadd",
			name: "kcgadds",
			title: "成果案例添加",
			component: () => import('@/pages/kcsz/xmcgadd')
		}]
	},
	// 大思政课管理
	{
		path: "/dszks",
		name: "dszks",
		meta: {
			title: "大思政课管理",
		},
		component: Layout,
		children: [{
			path: "/szzy",
			name: "szzyndex",
			title: "思政资源",
			component: () => import('@/pages/dszk/szzy')
		},{
			path: "/szzyadd",
			name: "szzyadd",
			title: "思政资源上传",
			component: () => import('@/pages/dszk/szzyadd')
		},{
			path: "/wtadd",
			name: "wtadd",
			title: "问题库上传",
			component: () => import('@/pages/dszk/wtadd')
		},{
			path: "/zysfkadd",
			name: "sfkadd",
			title: "示范课上传",
			component: () => import('@/pages/dszk/sfkadd')
		},{
			path: "/szjkindex",
			name: "szjkindex",
			title: "思政金课",
			component: () => import('@/pages/dszk/szjk')
		},{
			path: "/szjkadd",
			name: "szjkadd",
			title: "思政金课添加",
			component: () => import('@/pages/dszk/szjkadd')
		},{
			path: "/xmcgindex",
			name: "xmcgindex",
			title: "项目成果",
			component: () => import('@/pages/dszk/xmcg')
		},{
			path: "/xmcgadd",
			name: "xmcgadd",
			title: "项目成果添加",
			component: () => import('@/pages/dszk/xmcgadd')
		},{
			path: "/szzysh",
			name: "szzysh",
			title: "思政资源审核",
			component: () => import('@/pages/studiosh/szzysh.vue')
		}]
	},
	// 社会育人
	{
		path: "/shyr",
		name: "shyr",
		meta: {
			title: "社会育人",
		},
		component: Layout,
		children: [{
			path: "/shyr",
			name: "shyrlist",
			title: "社会育人列表",
			component: () => import('@/pages/shyr/index')
		},{
			path: "/shyradd",
			name: "shyradd",
			title: "社会育人添加",
			component: () => import('@/pages/shyr/shyradd')
		}]
	},
	//评价列表
	{
		path: "/pjxt",
		name: "pjxt",
		meta: {
			title: "评价系统",
		},
		component: Layout,
		children: [{
			path: "/cgpj",
			name: "cgpjs",
			title: "成果评价",
			component: () => import('@/pages/pjxt/index')
		},{
			path: "/gzspj",
			name: "gzspjs",
			title: "工作室评价",
			component: () => import('@/pages/pjxt/gzspj')
		}]
	},
	// 特色专题
	{
		path: "/special",
		name: "special",
		component: Layout,
		meta: {
			title: "特色专题",
		},
		children: [{
				path: "/speciallist",
				name: "speciallist",
				title: "自建专题列表",
				component: () => import('@/pages/special/speciallist')
			},
			{
				path: "/specialadd",
				name: "specialadd",
				title: "自建专题添加",
				component: () => import('@/pages/special/specialadd')
			},
			{
				path: "/specialcontent",
				name: "specialcontent",
				title: "添加任务",
				component: () => import('@/pages/special/specialcontent')
			},
			{
				path: "/specialclist",
				name: "specialclist",
				title: "专题资源列表",
				component: () => import('@/pages/special/specialclist')
			},
			{
				path: "/studiolist",
				name: "studio",
				title: "名师工作室列表",
				component: () => import('@/pages/studio/studiolist')
			},
			{
				path: "/sjtj",
				name: "sjtj",
				title: "数据统计",
				component: () => import('@/pages/special/sjtj')
			}
		]
	},
	{
		path: "/studio",
		name: "studio",
		component: Layout,
		meta: {
			title: "名师工作室",
		},
		children: [{
				path: "/studio",
				name: "studio",
				title: "名师工作室",
				component: () => import('@/pages/studio/index')
			},
			{
				path: "/studioadd",
				name: "studio",
				title: "创建名师工作室",
				component: () => import('@/pages/studio/studioadd')
			},
			{
				path: "/studiolist",
				name: "studio",
				title: "名师工作室列表",
				component: () => import('@/pages/studio/studiolist')
			},
			{
				path: "/studioinfo",
				name: "studio",
				title: "查看名师工作室",
				component: () => import('@/pages/studio/studioinfo')
			},
			{
				path: "/task",
				name: "studio",
				title: "发布任务",
				component: () => import('@/pages/studio/task')
			},
			{
				path: "/member",
				name: "studio",
				title: "参加成员",
				component: () => import('@/pages/studio/member')
			},
			{
				path: "/evaluate",
				name: "studio",
				title: "评价",
				component: () => import('@/pages/studio/evaluate')
			},
			{
				path: "/studiocy",
				name: "studio",
				title: "添加负责人/成员",
				component: () => import('@/pages/studio/studiocy')
			},
			{
				path: "/answer",
				name: "studio",
				title: "提交",
				component: () => import('@/pages/studio/answer')
			}
		]
	},
	{
		path: "/pubnews",
		name: "pubnews",
		meta: {
			title: "新闻发布"
		},
		component: Layout,
		children: [{
				path: "/pubnews",
				name: "pubnews",
				title: "新闻发布",
				component: () => import('@/pages/pubnews')
			},
			{
				path: "/addNews",
				name: "addNews",
				meta: {
					title: "新闻发布"
				},
				component: () => import('@/pages/pubnews/addNews')
			}
		]
	},
	{
		path: "/localadmin",
		name: "localadmin",
		meta: {
			title: "当前账号",
		},
		component: Layout,
		children: [{
			path: "/localadmin",
			name: "localadmin",
			title: "当前账号",
			component: () => import('@/pages/localadmin/index')
		}]
	},
	{
		path: "/pubid",
		name: "pubid",
		meta: {
			title: "新建发布账号",
		},
		component: Layout,
		children: [{
			path: "/pubid",
			name: "pubid",
			title: "新建发布账号",
			component: () => import('@/pages/pubid/index')
		},{
			path: "/pubidxy",
			name: "pubid",
			title: "新建学院账号",
			component: () => import('@/pages/pubid/xyindex')
		},{
			path: "/xyinfo",
			name: "pubid",
			title: "学院信息",
			component: () => import('@/pages/pubid/xyinfo')
		},{
			path: "/pubidinfo",
			name: "pubid",
			title: "教师信息",
			component: () => import('@/pages/pubid/info')
		}]
	},
	{
		path: "/pubidadmin",
		name: "pubidadmin",
		meta: {
			title: "发布账号管理",
		},
		component: Layout,
		children: [{
			path: "/pubidadmin",
			name: "pubidadmin",
			title: "发布账号管理",
			component: () => import('@/pages/pubidadmin/index')
		}]
	},
	{
		path: "/preview",
		name: "preview",
		component: Layout,
		meta: {
			title: "内容预览",
		},
		children: [{
				path: "/pptPre",
				name: "pptPre",
				title: "预览ppt",
				component: () => import('@/pages/preview/pptPre')
			},
			{
				path: "/pdfPre",
				name: "pdfPre",
				title: "预览pdf",
				component: () => import('@/pages/preview/pdfPre')
			},
			{
				path: "/pdfqj",
				name: "pdfqj",
				title: "预览pdf",
				component: () => import('@/pages/preview/pdfqj')
			},
			{
				path: "/videoPre",
				name: "videoPre",
				title: "预览视频",
				component: () => import('@/pages/preview/videoPre')
			},
			{
				path: "/videoyl",
				name: "videoyl",
				title: "预览视频",
				component: () => import('@/pages/preview/videoyl')
			},
			{
				path: "/textPre",
				name: "textPre",
				title: "预览文本",
				component: () => import('@/pages/preview/textPre')
			},
			{
				path: "/sfkPre",
				name: "sfkPre",
				title: "预览示范课",
				component: () => import('@/pages/preview/sfkPre')
			}
		]
	},
	{
		path: "*",
		name: "error",
		meta: {
			title: "错误"
		},
		component: () => import('@/pages/error')
	},
	{
		path: "/login",
		name: "login",
		meta: {
			title: '人民思政后台登录',
		},
		component: () => import('@/pages/login')
	},
	{
		path: "/bigData",
		name: "bigData",
		meta: {
			title: '大数据观测',
		},
		component: () => import('@/pages/bigData')
	}
]


export const routers = slideBar
